import React                  from 'react';
import PropTypes              from 'prop-types';
import Flux                   from '../../flux/Flux';
import Translations           from '../../utils/Translations';
import {getCommonTranslation} from "../../utils/TranslationHelper";

const DUMMY_PREVIEW_URL = '/assets/img/navbar/guest_dummy.jpg';

/**
 * @param {string} userPictureUrl
 * @param {string} placeholderClass
 * @returns {*}
 */
function getAvatarComponent(userPictureUrl, placeholderClass = '') {
	return userPictureUrl && !userPictureUrl.endsWith(DUMMY_PREVIEW_URL)
		? <span style={{'backgroundImage': `url("${userPictureUrl}")`}} className='guest-avatar__image' />
		: <span className={`icon -icon-user-full ${placeholderClass}`} />;
}

class ProfileFeedbackList extends React.Component {

	constructor(props) {
		super(props);
		this.inputEl           = null;
		this.send              = this.send.bind(this);
		this.onKeyUp           = this.onKeyUp.bind(this);
		this.onLoadMoreClick   = this.onLoadMoreClick.bind(this);
		this.onFocusInput      = this.onFocusInput.bind(this);
		this.onTextChanged     = this.onTextChanged.bind(this);
		this.enableFeedback    = this.enableFeedback.bind(this);

		this.state           = {
			sendButtonEnabled: false,
			tooLongText:       false,
			editable:          props.editable,
		};
	}

	componentDidMount() {
		Flux.Gallery.addFocusCommentsInputChangeListener(this.onFocusInput);
		Flux.Gallery.addEnableFeedbackListener(this.enableFeedback);
	}
	
	componentWillUnmount() {
		Flux.Gallery.removeFocusCommentsInputChangeListener(this.onFocusInput);
		Flux.Gallery.removeEnableFeedbackListener(this.enableFeedback);
	}

	send() {
		const comment      = this.inputEl.value.trim();
		this.inputEl.value = '';

		if (this.props.albumId) {
			Flux.Gallery.addComment(this.props.albumId, comment);
			this.setState(
				{
					editable: false,
				}
			);
		}
	}

	/**
	 * @param {Object} e
	 */
	onKeyUp(e) {
		const commentLength = this.inputEl.value.trim().length;
		if (e.key === 'Enter' && commentLength >= 1 && commentLength <= 1000) {
			this.send();
		}
	}

	onTextChanged() {
		const commentLength = this.inputEl.value.trim().length;
		const commentValid  = commentLength >= 1 && commentLength <= 1000;
		this.setState({
			sendButtonEnabled: commentValid,
			tooLongText:       !commentValid,
		});
	}


	/**
	 * @param {Object} e
	 */
	onLoadMoreClick(e) {
		if ((typeof e === 'object') && e.cancelable) {
			e.preventDefault();
		}

		Flux.Gallery.showMoreComments(this.props.albumId);
	}

	onFocusInput() {
		if (this.inputEl) {
			this.inputEl.focus();
		}
	}

	enableFeedback() {
		this.setState({
			editable: true,
		});
	}

	render() {
		const {tooLongText} = this.state;

		let placeholderDom = null;
		const itemsDom     = this.props.items.map(function(item, key) {
			return (
				<div className="feedback-list__row" key={key}>
					<div className="feedback-list__cell h-vertical-align-middle">
						<span className="feedback-list__avatar -margin-top-null">
							{getAvatarComponent(item.userPictureUrl, '-center')}
						</span>
					</div>
					<div className="feedback-list__cell -pad-no-left">
						<div className="feedback-list__title">
							<span className="h-color-highlight">{item.userName}</span>
						</div>
						<div className="feedback-list__comment">
							{item.comment}
						</div>
						<div className="feedback-list__info">
							<span className="feedback-list__date feedback-list__info__item">{item.date}</span>
						</div>

						{item.answer && <div className="feedback-list__answer">
							<span className="icon -icon-double-arrow-right-line"></span> {item.answer}
						</div>}

					</div>
				</div>
			);
		});

		if (itemsDom.length === 0) {
			placeholderDom = <div className="feedback-list__empty-placeholder h-text-align-center">
				<div className="feedback-list__empty-placeholder__row"
				     dangerouslySetInnerHTML={{__html: Translations.get('FeedbackEmptyText')}}
				></div>
			</div>;
		}

		return (
			<div className="feedback-list">
				{this.state.editable && <div className="feedback-list__row feedback-list__row--input">
					<div className="feedback-list__cell h-vertical-align-middle -pad-22px-left">
						<span className="feedback-list__avatar">{getAvatarComponent(this.props.userPictureUrl, '-background')}</span>
					</div>
					{Flux.Guest.isBlockedForComments()
						? <div className="feedback-list__cell h-width-full blocked-for-comments">
							{getCommonTranslation("blocked-for-comments")}
						</div>

						: <div className="feedback-list__cell h-width-full -pad-12px-left">
								<div className="feedback-list__input-container h-disp-inline-block -full-width-button-less">
									<input type="text"
									       className="feedback-list__input h-height-full"
									       placeholder={Translations.get('FeedbackInputPlaceholder')}
									       ref={(input) => this.inputEl = input} onKeyUp={this.onKeyUp}
									       onChange={this.onTextChanged}
									/>
								</div>
							<span className={'feedback-list__input-container__validation' + (tooLongText ? '' : ' h-hide')}>{Translations.get('FeedbackInputMaxLimit')}</span>
							<button disabled={!this.state.sendButtonEnabled ? 'disabled' : ''}
							        className="feedback-list__btn-submit btn--icon -icon-single-arrow-right-line -btn-color-special h-vertical-align-middle h-right -click-material -bold-19px-btn"
							        onClick={this.send}
							/>
						</div>
					}
				</div>}
				<div className="feedback-list__body-wrap" ref={this.props.updateBodyRef}>
					<div className="feedback-list__body">
						{itemsDom}
					</div>
					{placeholderDom}
				</div>
				{this.props.total > this.props.items.length && this.props.showLoadMoreButton &&
				<div className="feedback-list__footer h-text-align-center">
					<a href="" className="h-color-fg-hint" onClick={this.onLoadMoreClick}>
						<span className="icon -icon-arrow-down-full"></span>&nbsp;&nbsp;{Translations.get('FeedbackLoadMore')}
					</a>
				</div>}
			</div>
		);
	}
}

ProfileFeedbackList.propTypes = {
	albumId:            PropTypes.number,
	editable:           PropTypes.bool,
	items:              PropTypes.array,
	showLoadMoreButton: PropTypes.bool,
	total:              PropTypes.number,
	updateBodyRef:      PropTypes.func,
	userPictureUrl:     PropTypes.string,
};

ProfileFeedbackList.defaultProps = {
	albumId:            0,
	editable:           true,
	items:              [],
	showLoadMoreButton: true,
	total:              0,
	updateBodyRef:      null,
	userPictureUrl:     '',
};

export default ProfileFeedbackList;
